/* Cart drawer extras (approved canvas 26.09.2026), loaded on every page by sections/wa-gift-cart.liquid:
   1. WhatsApp gift bar: while a NUO4ANI… code is on the cart, one bar counted without the concealer replaces the
      campaign bar (three rewards, "code applied" line). Without such a code the campaign bar stays as it is.
   2. Rules sheet: "(vezi regulament)" and every link to the giveaway rules open the rules over the page.
   3. "Mai multe mai jos": a hint above the summary while the product list runs under it.
   4. Checkout guard: with a NUO4ANI… code, "Finalizează comanda" stops once when the gift would be lost. */
(function () {
  var GIFT_PRODUCT_ID = 14641159569731;
  var GIFT_THRESHOLD = 22999;
  var PREFIX = 'NUO4ANI';
  var RULES_PATH = '/pages/regulament-mega-giveaway-patru-ani-cu-nuo';
  var OFFER_PAGE = /\/pages\/concealer-cadou-/;
  var lastCart = null;

  var ICONS = {
    gift: '<svg width="16" height="16" viewBox="2.2 2.8 19.6 19.6" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><rect x="3" y="8" width="18" height="4"></rect><path d="M5 12v9h14v-9M12 8v13M12 8S10 3 7.5 4.5 9 8 12 8Zm0 0s2-5 4.5-3.5S15 8 12 8Z"></path></svg>',
    check: '<svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><circle cx="9" cy="9" r="9" fill="currentColor"></circle><path d="M5 9.2l2.6 2.6L13 6.4" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg>',
    tag: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 12V4h8l10 10-8 8L3 12Z"></path><circle cx="7.5" cy="7.5" r="1.3"></circle></svg>',
    scroll: '<span class="wa-scroll-icon" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M6 13l6 6 6-6"></path></svg></span>',
    down: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M6 13l6 6 6-6"></path></svg>',
    // The theme's close icon (snippets/icon.liquid 'close'), 16px like every other overlay (NUO UI).
    close: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.4"></path></svg>'
  };

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  // The shop's money format, shared with the other custom scripts (nuo-ui.js).
  function money(cents) {
    if (window.NuoUI) return window.NuoUI.money(cents);
    return new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.max(0, cents) / 100) + ' lei';
  }

  /* ------------------------------------------------------------------ 1. WhatsApp gift bar */

  function giftCode(cart) {
    var codes = (cart.discount_codes || []).map(function (d) { return d.code || ''; });
    var m = document.cookie.match(/(?:^|; )discount_code=([^;]*)/);
    if (m) codes.push(decodeURIComponent(m[1]));
    return codes.find(function (c) { return c.toUpperCase().indexOf(PREFIX) === 0; }) || null;
  }

  function buyTotal(cart) {
    // The threshold counts every other shipped product at its final price; the concealer never counts.
    return cart.items
      .filter(function (i) { return i.product_id !== GIFT_PRODUCT_ID && i.requires_shipping; })
      .reduce(function (s, i) { return s + i.final_line_price; }, 0);
  }

  // Threshold reached and concealer in the cart, yet Shopify does not apply the code: it expired or was used.
  function codeDead(cart, code) {
    var entry = (cart.discount_codes || []).find(function (d) { return (d.code || '').toUpperCase() === code.toUpperCase(); });
    var hasGift = cart.items.some(function (i) { return i.product_id === GIFT_PRODUCT_ID; });
    return !!entry && entry.applicable === false && hasGift && buyTotal(cart) >= GIFT_THRESHOLD;
  }

  // The whole order as the ordinary campaign bar counts it (every shipped line, a paid concealer included, minus
  // order-level discounts): free shipping and the giveaway follow this total, only the gift ignores the concealer.
  function orderTotal(cart) {
    var lines = cart.items.filter(function (i) { return i.requires_shipping; }).reduce(function (s, i) { return s + i.final_line_price; }, 0);
    var off = (cart.cart_level_discount_applications || []).reduce(function (s, d) { return s + d.total_allocated_amount; }, 0);
    return lines - off;
  }

  function threshold(native, name) {
    var v = parseFloat(native.getAttribute(name));
    return isFinite(v) && v > 0 ? v : GIFT_THRESHOLD;
  }

  function rewardNames(list) {
    var names = list.map(function (m) { return '<strong class="nuo-cart-milestones__reward">' + esc(m.label) + '</strong>'; });
    return names.length > 1 ? names.slice(0, -1).join(', ') + ' și ' + names[names.length - 1] : names.join('');
  }

  function barHtml(cart, code, native) {
    var giftLines = cart.items.filter(function (i) { return i.product_id === GIFT_PRODUCT_ID; });
    var buy = buyTotal(cart);
    var total = orderTotal(cart);
    var icons = native.querySelectorAll('.nuo-cart-milestones__icon');
    // Each reward is judged on its own total (Maria 30.09): a paid concealer already counts for shipping and the giveaway.
    var milestones = [
      { icon: ICONS.gift, label: 'Concealer cadou', threshold: GIFT_THRESHOLD, amount: buy },
      { icon: icons[0] ? icons[0].innerHTML : '', label: native.getAttribute('shipping-reward') || 'Transport gratuit', threshold: threshold(native, 'shipping-threshold'), amount: total },
      { icon: icons[1] ? icons[1].innerHTML : '', label: native.getAttribute('giveaway-reward') || 'Mega Giveaway', threshold: threshold(native, 'giveaway-threshold'), amount: total }
    ];
    milestones.forEach(function (m) { m.unlocked = m.amount >= m.threshold; m.left = m.threshold - m.amount; });
    var gift = milestones[0];
    var reached = gift.unlocked;
    var unlocked = milestones.filter(function (m) { return m.unlocked; });
    var locked = milestones.filter(function (m) { return !m.unlocked; });
    var sub = '<span class="nuo-wa-bar__sub">Concealerul nu intră în calculul pragului pentru cadou.</span>';
    var message;
    if (!locked.length) {
      message = 'Ai deblocat ' + rewardNames(milestones) + '. ' + (giftLines.length ? 'Finalizează comanda pentru înscriere.' : 'Adaugă concealerul în coș.');
    } else if (unlocked.length) {
      // Locked rewards grouped by what is still missing for each.
      message = 'Ai deblocat ' + rewardNames(unlocked) + '. ' + lockedText(locked) + (reached ? '' : sub);
    } else {
      message = lockedText(locked) + sub;
    }
    var cards = milestones.map(function (m) {
      var status = m.unlocked ? (native.getAttribute('unlocked-label') || 'Deblocat') : 'Prag ' + money(m.threshold);
      return '<div class="nuo-cart-milestones__item' + (m.unlocked ? ' is-unlocked' : '') + '">' +
        '<span class="nuo-cart-milestones__icon" aria-hidden="true">' + m.icon + '</span>' +
        '<span class="nuo-cart-milestones__copy"><span class="nuo-cart-milestones__label">' + esc(m.label) + '</span>' +
        '<span class="nuo-cart-milestones__status">' + esc(status) + '</span></span></div>';
    }).join('');
    var progress = Math.min(buy / GIFT_THRESHOLD, 1);
    var addGift = reached && !giftLines.length ? '<button type="button" class="button button--sm" data-nuo-wa-add-gift>Adaugă concealerul cadou</button>' : '';
    var cta = reached ? '' : '<a href="' + (OFFER_PAGE.test(location.pathname) ? '#wa-step-1' : '/collections/toate-produsele-makeup-skincare') +
      '" class="button button--sm" data-nuo-wa-choose><span>Alege produse</span>' + (OFFER_PAGE.test(location.pathname) ? ICONS.scroll : '') + '</a>';
    var chip = '<span class="nuo-wa-bar__code-value">' + ICONS.tag + '<strong>' + esc(code) + '</strong></span>';
    // "Applied" only once the concealer really is free (Maria 30.09); before that, the line says what applies it.
    // Threshold reached without the concealer: only the concealer is missing (Maria 30.09, second round).
    var codeLine = giftLines.some(isFree)
      ? ICONS.check + '<span>Codul tău ' + chip + ' e aplicat</span>'
      : reached && !giftLines.length
        ? '<span>Codul ' + chip + ' se aplică automat când adaugi concealerul în nuanța ta preferată.</span>'
        : '<span>Codul ' + chip + ' se aplică automat dacă adaugi produse de minimum 229,99 lei și concealerul în nuanța ta preferată.</span>';
    return '<p class="nuo-cart-milestones__message' + (!locked.length ? ' is-complete' : '') + '" aria-live="polite">' + message + '</p>' +
      '<p class="nuo-cart-milestones__rules"><a href="' + RULES_PATH + '" data-nuo-rules>(vezi regulament)</a></p>' +
      '<div class="nuo-cart-milestones__track" role="progressbar" aria-label="Progres beneficii coș" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(progress * 100) + '">' +
      '<span class="nuo-cart-milestones__fill" style="transform: scaleX(' + progress + ')"></span></div>' +
      '<div class="nuo-cart-milestones__list nuo-cart-milestones__list--3" aria-label="Beneficii disponibile">' + cards + '</div>' + cta + addGift +
      '<p class="nuo-wa-bar__code">' + codeLine + '</p>';
  }

  // "Mai ai X până la A + B" for the rewards that need the same amount; the gift says it counts other products only.
  function lockedText(locked) {
    var groups = [];
    locked.forEach(function (m) {
      var g = groups.find(function (x) { return x.left === m.left; });
      if (g) g.labels.push(m.label); else groups.push({ left: m.left, labels: [m.label] });
    });
    return 'Mai ai ' + groups.map(function (g) { return money(g.left) + ' până la ' + g.labels.join(' + '); }).join(' și ') + '.';
  }

  function renderBar() {
    var code = lastCart ? giftCode(lastCart) : null;
    if (code && codeDead(lastCart, code)) code = null; // the ordinary campaign bar tells the truth then
    document.querySelectorAll('[data-nuo-cart-progress-switcher]').forEach(function (sw) {
      var native = sw.querySelector('nuo-cart-milestones');
      var bar = sw.querySelector(':scope > .nuo-wa-bar');
      if (!code || !native) {
        sw.removeAttribute('data-nuo-wa-active');
        if (bar) bar.remove();
        return;
      }
      var html = barHtml(lastCart, code, native);
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'nuo-cart-milestones nuo-wa-bar';
        sw.appendChild(bar);
      }
      if (bar.getAttribute('data-html') !== html) {
        bar.innerHTML = html;
        bar.setAttribute('data-html', html);
      }
      sw.setAttribute('data-nuo-wa-active', '');
    });
  }

  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (cart) { lastCart = cart; keepCode(cart); renderBar(); updateHint(); }).catch(function () {});
  }

  /* Keep the code (Maria 30.09): Shopify's checkout drops a code the cart does not qualify for yet, and with it the
     discount_code cookie, so a customer who went to checkout under 229,99 lei came back without the gift. The code is
     remembered with its cart and its term (the ?exp of the offer link, else 48 h), and put back once, the same cart,
     when it is gone and no other code took its place. A finished order starts a new cart, so it is never put back
     after the order. */
  var MEMO_KEY = 'nuo_wa_code';
  var restoring = false;

  function readMemo() { try { return JSON.parse(localStorage.getItem(MEMO_KEY) || 'null'); } catch (e) { return null; } }

  function offerExp(code) {
    try {
      var o = JSON.parse(localStorage.getItem('nuo_wa_offer') || 'null');
      if (o && o.exp && (!o.code || o.code.toUpperCase() === code.toUpperCase())) return o.exp * 1000;
    } catch (e) {}
    return 0;
  }

  function keepCode(cart) {
    if (!cart || !cart.token) return;
    var code = giftCode(cart);
    var memo = readMemo();
    var now = Date.now();
    if (code) {
      var same = memo && memo.code.toUpperCase() === code.toUpperCase();
      var exp = offerExp(code) || (same && memo.exp) || now + 48 * 3600 * 1000;
      if (!same || memo.token !== cart.token || memo.exp !== exp) {
        try { localStorage.setItem(MEMO_KEY, JSON.stringify({ code: code, token: cart.token, exp: exp })); } catch (e) {}
      }
      return;
    }
    if (!memo || restoring || memo.exp <= now || memo.token !== cart.token) return;
    if ((cart.discount_codes || []).length) return; // another code is on the cart: leave the customer's choice alone
    restoring = true;
    fetch('/discount/' + encodeURIComponent(memo.code) + '?redirect=/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c || !c.items) return;
        lastCart = c;
        renderBar();
        // The drawer and the offer page re-read the cart: prices, the gift row and step 3 follow the restored code.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {});
  }

  document.addEventListener('cart:change', function (e) {
    if (e.detail && e.detail.cart) { lastCart = e.detail.cart; keepCode(lastCart); setTimeout(function () { renderBar(); updateHint(); }, 50); } else { refresh(); }
  });
  // A product added outside the theme forms (the offer page's product sheet) announces itself with cart:refresh.
  document.addEventListener('cart:refresh', refresh);
  // The drawer re-renders its sections after every change: put the bar back when the switcher is replaced.
  new MutationObserver(function () {
    if (lastCart && document.querySelector('[data-nuo-cart-progress-switcher]:not([data-nuo-wa-active])') && giftCode(lastCart)) renderBar();
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', function (e) {
    var choose = e.target.closest('[data-nuo-wa-choose]');
    if (!choose || choose.getAttribute('href') !== '#wa-step-1') return;
    e.preventDefault();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.hide === 'function') drawer.hide();
    var step1 = document.querySelector('.shopify-section--featured-collections');
    if (step1) setTimeout(function () { step1.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 250);
  });

  /* ------------------------------------------------------------------ 2. Rules sheet */

  var sheet = null;
  var rulesLoaded = false;

  function buildSheet() {
    sheet = document.createElement('dialog');
    sheet.className = 'nuo-sheet nuo-rules-sheet';
    sheet.setAttribute('aria-label', 'Regulament');
    sheet.innerHTML = '<div class="nuo-sheet__grip"><span></span></div>' +
      '<div class="nuo-sheet__head"><p class="nuo-sheet__title" data-nuo-rules-title>Regulament</p>' +
      '<button type="button" class="nuo-sheet__close" aria-label="Închide" data-nuo-rules-close>' + ICONS.close + '</button></div>' +
      '<div class="nuo-sheet__body prose" data-nuo-rules-body><p>Se încarcă regulamentul…</p></div>' +
      '<div class="nuo-sheet__foot nuo-rules-sheet__foot"><button type="button" class="button" data-nuo-rules-close data-nuo-rules-back>Înapoi</button></div>';
    sheet.addEventListener('click', function (e) {
      if (e.target === sheet) { closeSheet(); return; } // tap on the mask
      if (e.target.closest('[data-nuo-rules-close]')) closeSheet();
    });
    sheet.addEventListener('cancel', function (e) { e.preventDefault(); closeSheet(); });
    // Escape closes only the sheet, not the drawer under it.
    sheet.addEventListener('keydown', function (e) { if (e.key === 'Escape') e.stopPropagation(); });
    // Drag the grip or the header down to close (the NUO UI sheet gesture).
    dragToClose(sheet, closeSheet);
  }

  function dragToClose(el, close) {
    if (window.NuoUI) window.NuoUI.dragToClose(el, [el.querySelector('.nuo-sheet__grip'), el.querySelector('.nuo-sheet__head')], close);
  }

  function loadRules() {
    if (rulesLoaded) return;
    rulesLoaded = true;
    fetch(RULES_PATH, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var section = doc.querySelector('.shopify-section--main-page');
      var title = section && section.querySelector('h1');
      var body = section && section.querySelector('.prose');
      if (title) sheet.querySelector('[data-nuo-rules-title]').textContent = title.textContent.trim();
      if (body) {
        body.querySelectorAll('script, style').forEach(function (n) { n.remove(); });
        sheet.querySelector('[data-nuo-rules-body]').innerHTML = body.innerHTML;
      }
    }).catch(function () {
      rulesLoaded = false;
      sheet.querySelector('[data-nuo-rules-body]').innerHTML = '<p><a href="' + RULES_PATH + '">Deschide regulamentul</a></p>';
    });
  }

  // A drawer re-render (cart:refresh) or the drawer closing can take a dialog out of the page while it is still open,
  // and showModal() on an open dialog does nothing: close it and attach it again before it is shown.
  function attach(dlg, host) {
    var modal = true;
    try { modal = !dlg.open || dlg.matches(':modal'); } catch (e) {}
    if (dlg.isConnected && dlg.parentNode === host && modal) return;
    if (dlg.open) dlg.close();
    host.appendChild(dlg);
  }

  function openSheet(backLabel, host) {
    if (!sheet) buildSheet();
    // Opened from the cart, the sheet lives inside the drawer: the drawer's focus trap then treats its clicks as inside.
    attach(sheet, host);
    sheet.querySelector('[data-nuo-rules-back]').textContent = backLabel;
    loadRules();
    if (!sheet.open) sheet.showModal();
    sheet.querySelector('[data-nuo-rules-body]').scrollTop = 0;
    requestAnimationFrame(function () { requestAnimationFrame(function () { sheet.classList.add('is-open'); }); });
  }

  function closeSheet() {
    if (!sheet || !sheet.open) return;
    sheet.classList.remove('is-open');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    setTimeout(function () { sheet.close(); }, reduce ? 0 : 300);
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-nuo-rules], a[href*="' + RULES_PATH + '"]');
    if (!link || (sheet && sheet.contains(link))) return;
    e.preventDefault();
    e.stopPropagation();
    var drawer = link.closest('cart-drawer');
    openSheet(drawer ? 'Înapoi la coș' : (OFFER_PAGE.test(location.pathname) ? 'Înapoi la ofertă' : 'Înapoi'), drawer || document.body);
  }, true);

  /* ------------------------------------------------------------------ 3. "Mai multe mai jos" */

  var hint = null;
  var fade = null;

  function scroller(from) {
    var el = from;
    while (el) {
      if (el instanceof Element) {
        var oy = getComputedStyle(el).overflowY;
        if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight + 1) return el;
      }
      el = el.assignedSlot || el.parentNode || (el instanceof ShadowRoot ? el.host : null);
      if (el instanceof ShadowRoot) el = el.host;
    }
    return null;
  }

  function updateHint() {
    var drawer = document.querySelector('cart-drawer');
    var items = drawer && drawer.querySelector('.cart-drawer__items');
    var footer = drawer && drawer.querySelector('.cart-drawer__footer');
    var open = drawer && drawer.hasAttribute('open');
    if (!hint) {
      fade = document.createElement('div');
      fade.className = 'nuo-more-fade';
      hint = document.createElement('button');
      hint.type = 'button';
      hint.className = 'nuo-more-hint';
      hint.innerHTML = 'Mai multe mai jos' + ICONS.down;
      hint.addEventListener('click', function () {
        var d = document.querySelector('cart-drawer');
        var sc = d && scroller(d.querySelector('.cart-drawer__items'));
        if (sc) sc.scrollTo({ top: sc.scrollHeight, behavior: 'smooth' });
      });
    }
    // The drawer sits above the page, so the hint lives inside the summary (re-attached after every re-render).
    if (footer && hint.parentNode !== footer) {
      footer.insertBefore(fade, footer.firstChild);
      footer.insertBefore(hint, footer.firstChild);
    }
    var show = false;
    if (open && items && footer && items.lastElementChild) {
      show = items.lastElementChild.getBoundingClientRect().bottom > footer.getBoundingClientRect().top + 4;
    }
    hint.classList.toggle('is-visible', show);
    fade.classList.toggle('is-visible', show);
  }

  // Cheap polling while the drawer is open covers scrolling inside the drawer's shadow root, resizes and re-renders.
  setInterval(function () {
    var drawer = document.querySelector('cart-drawer');
    if ((drawer && drawer.hasAttribute('open')) || (hint && hint.classList.contains('is-visible'))) updateHint();
  }, 150);


  /* ------------------------------------------------------------------ 4. Checkout guard (Dragoș 26.09)
     With a NUO4ANI… code on the cart, "Finalizează comanda" (drawer or /cart) stops once when the gift would be lost:
       - threshold reached, no concealer in the cart -> "Nu uita concealerul cadou": pick a shade, one tap adds it and goes on
         to checkout (only once Shopify really made it free); "Continuă fără cadou" goes on and is not asked again for that cart;
       - concealer in the cart, threshold not reached -> "Concealerul nu e încă gratuit": back to the products, or pay it.
     The decision is taken on a FRESH cart (not the last one seen), and only when the code is really on the cart and at least
     one shade can be bought. Everyone else goes straight to checkout, as today. */

  var GIFT_HANDLE = 'everlast-high-coverage-concealer';
  var GUARD_KEY = 'nuo_wa_guard';
  var giftProduct = null;
  var guard = null;

  function loadGift() {
    if (giftProduct) return Promise.resolve(giftProduct);
    return fetch('/products/' + GIFT_HANDLE + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (p) { giftProduct = p; return p; });
  }

  // The same cart answered once is not asked again in this visit (a changed cart asks again).
  function cartSig(cart) { return cart.items.map(function (i) { return i.variant_id + 'x' + i.quantity; }).sort().join('|'); }
  function answered(cart) { try { return sessionStorage.getItem(GUARD_KEY) === cartSig(cart); } catch (e) { return false; } }
  function remember(cart) { try { sessionStorage.setItem(GUARD_KEY, cartSig(cart)); } catch (e) {} }

  // The code must be ON the cart (a cookie alone promises nothing) and still alive.
  function codeOnCart(cart) {
    return (cart.discount_codes || []).find(function (d) { return (d.code || '').toUpperCase().indexOf(PREFIX) === 0; }) || null;
  }
  function isFree(line) { return !!line && line.final_line_price <= line.original_line_price - line.original_price; }

  function guardCase(cart, product) {
    var entry = codeOnCart(cart);
    if (!entry || codeDead(cart, entry.code) || answered(cart)) return null;
    var gifts = cart.items.filter(function (i) { return i.product_id === GIFT_PRODUCT_ID; });
    var buy = buyTotal(cart);
    if (buy >= GIFT_THRESHOLD && !gifts.length) {
      // Shades not known yet (slow answer): ask anyway; the sheet fills them in when they arrive.
      var anyShade = !product || product.variants.some(function (v) { return v.available; });
      return anyShade ? 'missing' : null;
    }
    if (buy < GIFT_THRESHOLD && gifts.length && !gifts.some(isFree)) return 'paid';
    return null;
  }

  function goCheckout() { location.href = '/checkout'; }

  function buildGuard() {
    guard = document.createElement('dialog');
    guard.className = 'nuo-sheet nuo-sheet--fit nuo-guard';
    guard.setAttribute('aria-labelledby', 'nuo-guard-title');
    guard.innerHTML = '<div class="nuo-sheet__grip"><span></span></div>' +
      '<div class="nuo-sheet__head"><p class="nuo-sheet__title" id="nuo-guard-title" data-guard-title></p>' +
      '<button type="button" class="nuo-sheet__close" aria-label="Închide" data-guard-close>' + ICONS.close + '</button></div>' +
      '<div class="nuo-sheet__body nuo-guard__body" data-guard-body></div>' +
      '<div class="nuo-sheet__foot nuo-guard__foot" data-guard-foot></div>';
    guard.addEventListener('click', function (e) {
      if (e.target === guard || e.target.closest('[data-guard-close]')) closeGuard();
    });
    guard.addEventListener('cancel', function (e) { e.preventDefault(); closeGuard(); });
    guard.addEventListener('keydown', function (e) { if (e.key === 'Escape') e.stopPropagation(); });
    dragToClose(guard, closeGuard);
  }

  // The shade swatches the theme shows on the product (rendered by sections/wa-gift-cart.liquid), by shade name.
  var swatches = null;
  function swatchFor(name) {
    if (!swatches) { try { swatches = JSON.parse((document.getElementById('nuo-gift-swatches') || {}).textContent || '[]'); } catch (e) { swatches = []; } }
    return swatches.find(function (x) { return x.name === name; }) || {};
  }

  // Same option as the theme's "explicit variant selection" dialog: a rectangle with the swatch and the shade name.
  function shadeButtons(p) {
    return p.variants.map(function (v) {
      var sw = swatchFor(v.option1 || v.title);
      var bg = sw.image ? 'url(' + esc(sw.image) + ')' : (sw.color ? esc(sw.color) : '#d9c2a7');
      return '<button type="button" class="nuo-guard__shade" aria-pressed="false" data-variant="' + v.id + '" data-name="' + esc(v.title) + '"' + (v.available ? '' : ' disabled') + '>' +
        '<span class="nuo-guard__swatch" style="--nuo-swatch: ' + bg + '" aria-hidden="true"></span>' +
        '<span class="nuo-guard__shade-label">' + esc(v.title) + (v.available ? '' : '<small>stoc epuizat</small>') + '</span></button>';
    }).join('');
  }

  function giftImg(src) {
    if (!src) return '';
    var url = src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=160';
    return '<img src="' + esc(url) + '" alt="Concealer cu acoperire mare" width="80" height="80" loading="lazy">';
  }

  // The theme's own warning for "no shade chosen" (theme settings), else its default wording and colours.
  function explicitConfig() {
    try { return JSON.parse((document.getElementById('nuo-explicit-variant-config') || {}).textContent || '{}'); } catch (e) { return {}; }
  }

  function openGuard(kind, cart, host, fromBar) {
    if (!guard) buildGuard();
    attach(guard, host);
    var title = guard.querySelector('[data-guard-title]');
    var body = guard.querySelector('[data-guard-body]');
    var foot = guard.querySelector('[data-guard-foot]');
    var entry = codeOnCart(cart);
    if (kind === 'missing') {
      title.textContent = 'Nu uita concealerul cadou';
      body.innerHTML = '<p class="nuo-guard__lead">Ai produse de minimum 229,99 lei în coș, deci concealerul e <strong>gratuit</strong> cu codul tău ' +
        '<strong>' + esc(entry ? entry.code : '') + '</strong>.</p>' +
        // Photo and a way to the product page, for whoever wants to see the shades before choosing (Maria 30.09).
        '<div class="nuo-guard__product"><span class="nuo-guard__img">' + (giftProduct ? giftImg(giftProduct.featured_image) : '') + '</span>' +
        '<a class="link" href="/products/' + GIFT_HANDLE + '">Vezi nuanțele pe pagina produsului</a></div>' +
        '<p class="nuo-guard__picked">Culoare: <span data-guard-picked>Alege nuanța</span></p>' +
        '<div class="nuo-guard__shades" role="radiogroup" aria-label="Nuanța" data-guard-shades>' +
        (giftProduct ? shadeButtons(giftProduct) : '<p class="nuo-guard__loading">Se încarcă nuanțele…</p>') + '</div>' +
        '<p class="nuo-guard__error" data-guard-error hidden></p>';
      foot.innerHTML = '<p class="nuo-guard__alert" data-guard-alert role="alert" hidden></p>' +
        '<button type="button" class="button" data-guard-add>' +
        '<span class="button-text">' + (fromBar ? 'Adaugă cadoul în coș' : 'Adaugă cadoul și finalizează') + '</span><span class="button-loader-brown"></span></button>' +
        (fromBar ? '' : '<button type="button" class="nuo-guard__skip" data-guard-skip>Continuă fără cadou</button>');
    } else {
      var gifts = cart.items.filter(function (i) { return i.product_id === GIFT_PRODUCT_ID; });
      var paid = gifts.reduce(function (s, i) { return s + i.final_line_price; }, 0);
      title.textContent = 'Concealerul nu e încă gratuit';
      var buy = buyTotal(cart);
      body.innerHTML = '<p class="nuo-guard__lead">' + (buy > 0
        ? 'Mai ai <strong>' + money(GIFT_THRESHOLD - buy) + '</strong> până la pragul de 229,99 lei '
        : 'Adaugă și alte produse NUO de minimum <strong>229,99 lei</strong> ') +
        '(concealerul nu intră în calcul), așa că acum îl plătești: ' + money(paid) + '.</p>';
      foot.innerHTML = '<a class="button" href="' + (OFFER_PAGE.test(location.pathname) ? '#wa-step-1' : '/collections/toate-produsele-makeup-skincare') + '" data-guard-shop><span>Alege produse</span>' + (OFFER_PAGE.test(location.pathname) ? ICONS.scroll : '') + '</a>' +
        '<button type="button" class="nuo-guard__skip" data-guard-skip>Continuă și plătesc concealerul</button>';
    }
    if (kind === 'missing' && !giftProduct) {
      loadGift().then(function (p) {
        var box = guard.querySelector('[data-guard-shades]'); if (box) box.innerHTML = shadeButtons(p);
        var img = guard.querySelector('.nuo-guard__img'); if (img) img.innerHTML = giftImg(p.featured_image);
      })
        .catch(function () { var box = guard.querySelector('[data-guard-shades]'); if (box) box.innerHTML = '<p>Nu am putut încărca nuanțele. <a href="/products/' + GIFT_HANDLE + '">Alege concealerul aici</a>.</p>'; });
    }
    guard.dataset.kind = kind;
    if (!guard.open) guard.showModal();
    requestAnimationFrame(function () { requestAnimationFrame(function () { guard.classList.add('is-open'); }); });

    guard.onclick = function (e) {
      var shade = e.target.closest('.nuo-guard__shade');
      if (shade && !shade.disabled) {
        guard.querySelectorAll('.nuo-guard__shade').forEach(function (s) { s.setAttribute('aria-pressed', String(s === shade)); });
        guard.querySelector('[data-guard-picked]').textContent = shade.getAttribute('data-name');
        // The photo follows the chosen shade when the shade has its own.
        var v = giftProduct && giftProduct.variants.find(function (x) { return String(x.id) === shade.getAttribute('data-variant'); });
        var box = guard.querySelector('.nuo-guard__img');
        if (box && v && v.featured_image && v.featured_image.src) box.innerHTML = giftImg(v.featured_image.src);
        guard.querySelector('[data-guard-alert]').hidden = true;
        return;
      }
      if (e.target.closest('[data-guard-skip]')) { remember(cart); closeGuard(); goCheckout(); return; }
      if (e.target.closest('[data-guard-shop]')) {
        remember(cart);
        closeGuard();
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.hide === 'function') drawer.hide();
        if (OFFER_PAGE.test(location.pathname)) {
          e.preventDefault();
          var step1 = document.querySelector('.shopify-section--featured-collections');
          if (step1) setTimeout(function () { step1.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 250);
        }
        return;
      }
      var add = e.target.closest('[data-guard-add]');
      if (add && !add.disabled) addGift(add, fromBar);
    };
  }

  function addGift(add, fromBar) {
    var picked = guard.querySelector('.nuo-guard__shade[aria-pressed="true"]');
    if (!picked) {
      // No disabled button: the tap explains what is missing, like the theme does on product pages.
      var cfg = explicitConfig(), alert = guard.querySelector('[data-guard-alert]');
      alert.textContent = cfg.errorLabel || 'Selectează o nuanță înainte de adăugare.';
      if (cfg.alertBackground) alert.style.background = cfg.alertBackground;
      if (cfg.alertTextColor) alert.style.color = cfg.alertTextColor;
      alert.hidden = false;
      // Like the theme's shade warning: it goes away by itself after 4.5 s.
      clearTimeout(alert._hide);
      alert._hide = setTimeout(function () { alert.hidden = true; }, 4500);
      return;
    }
    var err = guard.querySelector('[data-guard-error]');
    err.hidden = true;
    add.setAttribute('aria-busy', 'true');
    add.disabled = true;
    var json = { 'Content-Type': 'application/json' };
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: json, body: JSON.stringify({ items: [{ id: +picked.getAttribute('data-variant'), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return fetch('/cart.js', { credentials: 'same-origin' }); })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var line = c.items.find(function (i) { return i.product_id === GIFT_PRODUCT_ID; });
        if (isFree(line)) {
          lastCart = c;
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (fromBar) closeGuard(); else goCheckout();
          return;
        }
        // Shopify did not make it free (code expired or already used): take it out again and say so plainly.
        return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: json, body: JSON.stringify({ id: line ? line.key : '', quantity: 0 }) })
          .then(function (r) { return r.json(); })
          .then(function (c2) {
            lastCart = c2;
            // Not asked again for this cart: the next "Finalizează comanda" goes straight to checkout.
            remember(c2);
            // The drawer re-renders once the message is closed; a re-render now would take the open guard with it.
            guard.addEventListener('close', function () { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); }, { once: true });
            err.textContent = 'Codul tău nu se mai aplică (a expirat sau a fost deja folosit), așa că nu am adăugat concealerul. Poți finaliza comanda fără el.';
            err.hidden = false;
            add.hidden = true;
            if (!guard.querySelector('[data-guard-skip]')) {
              guard.querySelector('[data-guard-foot]').insertAdjacentHTML('beforeend', '<button type="button" class="nuo-guard__skip" data-guard-close>Închide</button>');
            }
          });
      })
      .catch(function () {
        add.removeAttribute('aria-busy');
        add.disabled = false;
        err.textContent = 'Nu s-a putut adăuga concealerul. Încearcă din nou.';
        err.hidden = false;
      });
  }

  function closeGuard() {
    if (!guard || !guard.open) return;
    guard.classList.remove('is-open');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    setTimeout(function () { guard.close(); }, reduce ? 0 : 300);
  }

  // "Finalizează comanda" in the drawer and on /cart: both are submit buttons named "checkout". Only a visitor with a
  // NUO4ANI… code is held for the moment it takes to read the cart; everyone else submits as before.
  document.addEventListener('submit', function (e) {
    var btn = e.submitter;
    if (!btn || btn.name !== 'checkout' || btn.hasAttribute('data-nuo-guard-pass')) return;
    var cookieCode = (document.cookie.match(/(?:^|; )discount_code=([^;]*)/) || [])[1];
    var hasCode = (lastCart && codeOnCart(lastCart)) || (cookieCode && decodeURIComponent(cookieCode).toUpperCase().indexOf(PREFIX) === 0);
    if (!hasCode) return;
    e.preventDefault();
    e.stopPropagation();
    btn.setAttribute('aria-busy', 'true');
    var host = btn.closest('cart-drawer') || document.body;
    // Never hold the customer: the cart must answer within 5 s (else straight to checkout), the shades within 1.5 s (else later).
    var within = function (ms, promise, fallback) { return Promise.race([promise, new Promise(function (res) { setTimeout(function () { res(fallback); }, ms); })]); };
    var TIMEOUT = {};
    Promise.all([within(5000, fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }), TIMEOUT),
                 within(1500, loadGift().catch(function () { return null; }), null)])
      .then(function (res) {
        var cart = res[0];
        if (cart === TIMEOUT) { btn.removeAttribute('aria-busy'); goCheckout(); return; }
        lastCart = cart;
        var kind = guardCase(cart, res[1]);
        btn.removeAttribute('aria-busy');
        if (kind) openGuard(kind, cart, host, false); else goCheckout();
      })
      .catch(function () { btn.removeAttribute('aria-busy'); goCheckout(); });
  }, true);

  // Shortcut from the bar ("prag atins, fără concealer"): the same shade picker, without going to checkout.
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-nuo-wa-add-gift]');
    if (!b || !lastCart) return;
    e.preventDefault();
    loadGift().then(function () { openGuard('missing', lastCart, b.closest('cart-drawer') || document.body, true); });
  });
  // Shades are fetched ahead only for visitors who carry a WhatsApp code; nobody else pays for the request.
  if (/(?:^|; )discount_code=NUO4ANI/i.test(document.cookie)) loadGift().catch(function () {});

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
})();
